"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingBarStart = void 0;
var react_1 = __importStar(require("react"));
var uniqueId_1 = __importDefault(require("lodash/uniqueId"));
var build_svg_icon_1 = require("./build-svg-icon");
var RatingBar_module_css_1 = __importDefault(require("./RatingBar.module.css"));
exports.RatingBarStart = (0, build_svg_icon_1.buildSvgIcon)(function (props) {
    /* To create the bar percentage we need to create a linearGradient mask
     if the mask id collides with another id, the browser defaults to a no-op
     and doesn't render the bar, thus we need to ensure each maskId is unique
    */
    var _a = __read((0, react_1.useState)((0, uniqueId_1.default)('bar-icon-')), 1), randomId = _a[0];
    var barProps = props ? props : {};
    var fillPercentage = typeof barProps.fillPercentage === 'number'
        ? barProps.fillPercentage
        : 100;
    var offsetPercentage = Math.round(fillPercentage * 100);
    var stopColorClassName = barProps.variation === 'secondary'
        ? RatingBar_module_css_1.default.stopColorSecondary
        : RatingBar_module_css_1.default.stopColor;
    var fillClassName;
    if (fillPercentage === 100) {
        fillClassName =
            barProps.variation === 'secondary'
                ? RatingBar_module_css_1.default.fillColorSecondary
                : RatingBar_module_css_1.default.fillColor;
    }
    else if (fillPercentage === 0) {
        fillClassName = RatingBar_module_css_1.default.emptyColor;
    }
    var isValidPercentage = fillPercentage > 0 && fillPercentage < 100;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isValidPercentage && (react_1.default.createElement("defs", null,
            react_1.default.createElement("linearGradient", { id: "offset-".concat(randomId) },
                react_1.default.createElement("stop", { offset: "0%", className: stopColorClassName }),
                react_1.default.createElement("stop", { offset: "".concat(offsetPercentage, "%"), className: stopColorClassName }),
                react_1.default.createElement("stop", { offset: "".concat(offsetPercentage, "%"), className: RatingBar_module_css_1.default.stopColorEmpty }),
                react_1.default.createElement("stop", { offset: "100%", className: RatingBar_module_css_1.default.stopColorEmpty })))),
        react_1.default.createElement("path", { className: fillClassName, fill: fillClassName === undefined ? "url(#offset-".concat(randomId, ")") : undefined, fillRule: "evenodd", clipRule: "evenodd", d: "M0.0429688 2.5C0.0429688 1.39543 0.938399 0.5 2.04297 0.5H29.4596V5.5H2.04297C0.938398 5.5 0.0429688 4.60457 0.0429688 3.5V2.5Z" })));
}, 'RatingBarStart', { viewBox: '0 0 30 6' });
exports.default = exports.RatingBarStart;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/icons/icons/RatingBarStart.js
// module id = 3532
// module chunks = 25